export default __webpack_public_path__ + "static/media/SJA1360.34I-41595_-24879_0.912f0f8f.jpg";